import { useSpaceIDFromPath } from '@/data/space/hooks';
import { useGetSpaceQuery } from '@/store';
import { ArrowRight } from '@phosphor-icons/react';
import { Search } from '@styled-icons/boxicons-regular';
import { Text } from '@typedream/ui';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import { useContext, useEffect, useState } from 'react';
import ButtonBoxBorder from '../../../sharedComponents/Button/ButtonBoxBorder';
import OptionsContainer from '../../../sharedComponents/Options';
import { DEFAULT_WIDTH_COLUMNS } from '../../../sharedComponents/TextEditor/components/SideToolbar/helpers/constants';
import sharedStyles from '../../../styles/Shared.module.css';
import ImageOrImg from '../../ImageOrImg';
import styles from '../SaveTemplatePopup.module.css';
import { SaveTemplatePopupContext } from '../contextProvider';
import { SAVE_TEMPLATE_PAGE } from '../types';

function ExistingOrNew() {
  const router = useRouter();
  const spaceID = useSpaceIDFromPath();
  const { data: space } = useGetSpaceQuery([spaceID], { skip: !spaceID });
  const { setstep, templates, settemplateToUpdate, err } = useContext(SaveTemplatePopupContext);

  const [searchQuery, setsearchQuery] = useState('');
  const [filteredTemplates, setfilteredTemplates] = useState(templates);

  useEffect(() => {
    if (searchQuery) {
      const filtered = Object.values(templates).filter((item) =>
        item.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setfilteredTemplates(filtered);
    } else {
      setfilteredTemplates(templates);
    }
  }, [searchQuery, templates]);

  return (
    <div>
      <div className={classNames('is-size-5 with-text-color mb-3')}>Save Template</div>
      <div className="is-subtitle mb-4">Save this page as a template that you can reuse later.</div>
      <ButtonBoxBorder onClick={() => setstep(SAVE_TEMPLATE_PAGE.CREATE)}>
        Create a new template &rarr;
      </ButtonBoxBorder>
      <div className="is-subtitle mb-5 mt-5">or</div>
      <div className="has-text-weight-medium with-text-color mb-4">Update an existing template</div>
      <div
        className={classNames(
          sharedStyles.inputMedium,
          'has-fit-content-width is-flex is-justify-content-space-between is-align-items-center mb-3'
        )}
      >
        <div className="is-subtitle mr-2">
          <Search size={20} />
        </div>

        <input
          className={classNames(sharedStyles.inputWithPrefix, 'is-flex-grow-1')}
          type="text"
          value={searchQuery}
          placeholder="Search by Template Name"
          onChange={(e) => setsearchQuery(e.target.value)}
        />
      </div>
      <div
        className={classNames(styles.templatesContainer, 'flex flex-col gap-4 scrollbox')}
        style={{
          maxWidth: DEFAULT_WIDTH_COLUMNS,
        }}
      >
        {filteredTemplates &&
          Object.values(filteredTemplates).map((item) => (
            <OptionsContainer
              selected={false}
              disabled={false}
              className="p-3"
              onClick={() => {
                if (item.metadata?.page_id) {
                  router.push(`/settings/${space.slug}/${spaceID}/templates/${item.id}`);
                  return;
                }
                settemplateToUpdate(item);
                setstep(SAVE_TEMPLATE_PAGE.UDPATE);
              }}
            >
              <div className="flex items-center w-full gap-3">
                <ImageOrImg
                  className="h-full w-full rounded"
                  src={item.preview}
                  width={90}
                  height={45}
                  objectFit="cover"
                />
                <div className="flex flex-col flex-1 gap-1">
                  <Text size="sm" weight="medium" variant="primary-soft">
                    {item.name}
                  </Text>

                  <Text size="2xs" variant="secondary">
                    {item.description}
                  </Text>
                </div>
                <ArrowRight size={16} weight="bold" className="text-secondary" />
              </div>
            </OptionsContainer>
          ))}
      </div>
      {err && <div className="with-danger-text-color">{err}</div>}
    </div>
  );
}

export default ExistingOrNew;
